const API_CONFIG = {
  // BASE_URL: 'https://orgi-api.sconexsoft.com/orgi',//PROD
  BASE_URL: 'https://orgi-dev-api.sconexsoft.com/orgi',//DEV
  SERVICE_URL: 'https://s3service.sconexsoft.com',

  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/v1/auth',
      REGISTER: 'api/register'
    },
    BATCH_TRANSACTIONS: {
      GROUPED: 'batch-transactions/abstractview',
      GROUPED_BY_PRODUCT: 'batch-transactions/abstractview/:runId/:productId/:companyName/:brandName',
      PRODUCTS_BY_IMAGE: '/batch-transactions/products-by-image/:runId/:imageName',
    },
    DETAILED_VIEW: {
      IMAGE_COUNT: '/detailed-view/image-summary',
    },
    PRODUCT_COMPANIES: '/product-companies',
    STORE_DETAILS: '/store-details',
    MODEL_DETAILS: 'model-details',
    MODEL_REPORT: {
      MATCHED_SKU_COUNT: 'model-evaluation/matchedsku-count/:model/:iteration',
      DETAIL: 'model-evaluation/detailed-view/:model/:iteration',
    },
    MODEL_EVALUATION: {
      DISTINCT_ITERATIONS: 'model-details/distinct-iterations/:model',
      ABSTRACT_COUNTS: 'model-evaluation/abstract-counts/:model/:iteration',
      PRODUCTS: 'model-evaluation/abstract-counts/products/:model/:iteration',
      BRANDS: 'model-evaluation/abstract-counts/brands/:model/:iteration',
      PACK_TYPES: 'model-evaluation/abstract-counts/pack-types/:model/:iteration',
      PACK_SIZES: 'model-evaluation/abstract-counts/pack-sizes/:model/:iteration',
      SKU_DETAILS: 'model-evaluation/sku-details/:model/:iteration/:sku',
    },
    SOURCE_DETAILS: {
      FILE_NAMES: 'source-details/file-names',
      PRODUCT_NAMES: 'source-details/product-names',
      BY_IMAGE: 'source-details/:imageName',
      GET_CLASS_ID: 'source-details/get-classId',
      ADD_RECORD: 'source-details/add-record',
      DELETE_RECORD: 'source-details/delete-record',
      UPDATE_RECORD: 'source-details/sourcetable/update/:actualFileName/:classId',
    },
    ANALYTICS: {
      BRAND_COUNTS: 'analytics/brand-counts',
      PACKSIZE_COUNTS: 'analytics/packsize-counts',
      PRODUCTS_COUNTS: 'analytics/product-counts',
    },
    RUNTIME: '/runstatus',
    STATUS: {
      ACTIVE: 'status/active',
      INACTIVE: 'status/inactive',
    },
    VISIBILITY_ITEMS: '/visibility-items',
    VISIBILITY_ITEMS_1: 'target-visibility-items/:model/:iteration',
    EXECUTIVE_COUNT: {
      DATES: 'file-upload/data/dates',
      CATEGORY_WISE: 'file-upload/data/categorywise?date=:date',
      STORE_WISE: 'file-upload/data/storewise?date=:date',
      EXECUTIVE_CATEGORY: 'file-upload/data/executivewise?date=:date',
      EXECUTIVE_IMAGE: 'file-upload/data/executivewisecount?date=:date',
    },
    STORE_REPORT: {
      RECALCULATION:'/aicalc/calculate-score',
       SCORES:'/red-master/store-scores',
       STORE_SEARCH:'/red-master/store-search',
       CITYDP:'/red-master/asm-cities',
       CHANNELDP:'/red-master/channels',
       UPDATE:'/batch-transactions/update-product',
       GET_PRODUCTS:'/batch-transactions/get-product',
    },
    RED_SCORE: 'red-score',
    ASM_REPORT: {
      REGIONDP: "/red-master/regions",
      SUBREGIONDP: "/red-master/sub-regions",
      CITYDP: "/red-master/cities",
      CHANNELDP: "/red-master/channels",
      TYPEDP: "/red-master/store-types",
      MANAGERS: "/red-master/asm-details",
      SCORES: "/red-master/scores",
      ASM: "/red-master/search",
      ASMNAMES: "/red-master/asm-cities",
      ChannelScores: "/red-master/graph-scores",
      DISTRIBUTOR: "/red-master/distributor-details",
      SO_STORES:"/red-master/stores",
      ABSTRACTVIEW:"/red-master/store-details",//same as store report abstract view
      },

  
    DASHBOARD: '/dashboard/analytics/audited-stores',
    // STOREADUITED: '/red-score/audited-stores'
    VISICOOLER: {
      ASMDP: "/red-master/dropdown",
      STORE_WISE_IMAGES:'/v1/file-upload/cooler-images'
    },

    RED_FRESHNESS: {
      REPORT: '/api/red-freshness/report',
    },

    SOVI: {
      REPORT: '/api/sovi-report',
    },
    STORE_ABSTRACT: {
      REPORT: '/api/abstract-store-report',
    },
    ROLE_BASED_ACCESS: {
      ROLES: '/api/roles',
      ROLE_MENU: '/api/role-menu',
    },
  },
};

export default API_CONFIG;